(function () {
  if (window.__bcPanelsV3Loaded) return;
  window.__bcPanelsV3Loaded = true;

  var root = document.querySelector('[data-bc-root]');
  if (root && !document.querySelector('script[src*="bc-core.js"]')) {
    var src = root.getAttribute('data-bc-core-src');
    if (src) {
      var core = document.createElement('script');
      core.src = src;
      core.defer = true;
      document.body.appendChild(core);
    }
  }

  var home = document.querySelector('.bc-home[data-bc-root]');
  if (!home) return;

  var STARS5 = '\u2605\u2605\u2605\u2605\u2605';

  function bcT(key) {
    if (window.BC_I18N && window.BC_I18N.t) return window.BC_I18N.t(key);
    return key;
  }

  function tradeLabel(trade) {
    var key = 'trade.' + trade;
    var label = bcT(key);
    return label === key ? trade : label;
  }

  function ensurePanelRoot() {
    var existing = home.querySelector('[data-bc-panel-root]');
    if (existing) return existing;
    var root = document.createElement('div');
    root.className = 'bc-panel-root';
    root.setAttribute('data-bc-panel-root', '');
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="bc-panel-backdrop" data-bc-panel-close></div>' +
      '<div class="bc-panel" role="dialog" aria-modal="true" aria-labelledby="bc-panel-title">' +
      '<div class="bc-panel-hero-wrap"><img class="bc-panel-hero" data-bc-panel-hero src="" alt="" width="800" height="200">' +
      '<button type="button" class="bc-panel-close bc-panel-close--hero" data-bc-panel-close aria-label="Close">\u2715</button></div>' +
      '<div class="bc-panel-head"><button type="button" class="bc-panel-close bc-panel-close--head" data-bc-panel-close aria-label="Close">\u2715</button>' +
      '<h2 id="bc-panel-title" data-bc-panel-title></h2>' +
      '<p class="bc-panel-sub" data-bc-panel-sub></p></div>' +
      '<div class="bc-panel-body" data-bc-panel-body></div></div>';
    home.appendChild(root);
    return root;
  }

  function wireLegacyPanelLinks() {
    var map = {
      'Find a Pro': 'find-pro',
      'How It Works': 'how-it-works',
      Reviews: 'reviews',
      'For Pros': 'for-pros',
      Resources: 'resources',
      Contact: 'feedback',
      Help: 'resources',
      Services: 'services'
    };
    home.querySelectorAll('.bc-nav a, .bc-footer-links a, .bc-mobile-nav a').forEach(function (a) {
      if (a.getAttribute('data-bc-open-panel')) return;
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (map[label]) {
        a.href = '#';
        a.setAttribute('data-bc-open-panel', map[label]);
        return;
      }
      if (a.href && a.href.indexOf('mailto:') === 0) {
        a.href = '#';
        a.setAttribute(
          'data-bc-open-panel',
          /pro|application/i.test(a.href + label) ? 'for-pros' : 'feedback'
        );
      }
    });
    home.querySelectorAll('.bc-location').forEach(function (el) {
      if (!el.getAttribute('data-bc-open-panel')) el.setAttribute('data-bc-open-panel', 'location');
    });
    home.querySelectorAll('.bc-review-trigger, .bc-score, .bc-review-all-btn, .bc-platform, .bc-customers').forEach(function (el) {
      if (!el.getAttribute('data-bc-open-panel')) el.setAttribute('data-bc-open-panel', 'reviews');
    });
    home.querySelectorAll('.bc-feature').forEach(function (el, idx) {
      if (!el.getAttribute('data-bc-open-panel')) {
        el.setAttribute('data-bc-open-panel', ['how-it-works', 'feedback', 'resources'][idx] || 'resources');
      }
    });
    var svcPanel = {
      Plumbing: 'svc-plumbing',
      Electrical: 'svc-electrical',
      Painting: 'svc-painting',
      Moving: 'svc-moving',
      Cleaning: 'svc-cleaning',
      HVAC: 'svc-hvac'
    };
    home.querySelectorAll('[data-bc-service-link]').forEach(function (a) {
      var svc = a.getAttribute('data-bc-service-link');
      if (svc && svcPanel[svc] && !a.getAttribute('data-bc-open-panel')) {
        a.href = '#';
        a.setAttribute('data-bc-open-panel', svcPanel[svc]);
      }
    });
    home.querySelectorAll('[data-bc-book-service]').forEach(function (el) {
      var svc = el.getAttribute('data-bc-book-service');
      if (svc && svcPanel[svc] && !el.getAttribute('data-bc-open-panel')) {
        if (el.tagName === 'A') el.href = '#';
        el.setAttribute('data-bc-open-panel', svcPanel[svc]);
      }
    });
  }

  wireLegacyPanelLinks();
  var panelRoot = ensurePanelRoot();
  if (!panelRoot) return;

  var titleEl = panelRoot.querySelector('[data-bc-panel-title]');
  var subEl = panelRoot.querySelector('[data-bc-panel-sub]');
  var bodyEl = panelRoot.querySelector('[data-bc-panel-body]');
  var heroEl = panelRoot.querySelector('[data-bc-panel-hero]');
  var lastFocus = null;
  var bodyScrollY = 0;

  function lockBodyScroll() {
    bodyScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + bodyScrollY + 'px';
    document.body.classList.add('bc-panel-open');
  }

  function unlockBodyScroll() {
    document.body.classList.remove('bc-panel-open');
    document.body.style.top = '';
    window.scrollTo(0, bodyScrollY);
  }

  function toast(msg) {
    if (typeof window.__bcShowToast === 'function') window.__bcShowToast(msg);
    else {
      var t = home.querySelector('[data-bc-toast]');
      if (!t) return;
      t.textContent = msg;
      t.hidden = false;
      clearTimeout(toast._t);
      toast._t = setTimeout(function () {
        t.hidden = true;
      }, 4200);
    }
  }

  var HERO = {
    'find-pro':
      'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80',
    'how-it-works':
      'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80',
    reviews:
      'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1200&q=80',
    'for-pros':
      'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=80',
    resources:
      'https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&w=1200&q=80',
    feedback:
      'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80',
    location:
      'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?auto=format&fit=crop&w=1200&q=80',
    services:
      'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&w=1200&q=80'
  };

  var _bcData = JSON.parse(atob('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'));
  var US_CITIES = _bcData.cities;
  var REVIEW_QUOTES = _bcData.quotes;

  var US_STATES = [
    ['Alabama', 'AL', 'Birmingham', '35203'],
    ['Alaska', 'AK', 'Anchorage', '99501'],
    ['Arizona', 'AZ', 'Phoenix', '85001'],
    ['Arkansas', 'AR', 'Little Rock', '72201'],
    ['California', 'CA', 'Los Angeles', '90001'],
    ['Colorado', 'CO', 'Denver', '80201'],
    ['Connecticut', 'CT', 'Hartford', '06101'],
    ['Delaware', 'DE', 'Wilmington', '19801'],
    ['District of Columbia', 'DC', 'Washington', '20001'],
    ['Florida', 'FL', 'Miami', '33101'],
    ['Georgia', 'GA', 'Atlanta', '30301'],
    ['Hawaii', 'HI', 'Honolulu', '96801'],
    ['Idaho', 'ID', 'Boise', '83701'],
    ['Illinois', 'IL', 'Chicago', '60601'],
    ['Indiana', 'IN', 'Indianapolis', '46201'],
    ['Iowa', 'IA', 'Des Moines', '50301'],
    ['Kansas', 'KS', 'Wichita', '67201'],
    ['Kentucky', 'KY', 'Louisville', '40201'],
    ['Louisiana', 'LA', 'New Orleans', '70112'],
    ['Maine', 'ME', 'Portland', '04101'],
    ['Maryland', 'MD', 'Baltimore', '21201'],
    ['Massachusetts', 'MA', 'Boston', '02101'],
    ['Michigan', 'MI', 'Detroit', '48201'],
    ['Minnesota', 'MN', 'Minneapolis', '55401'],
    ['Mississippi', 'MS', 'Jackson', '39201'],
    ['Missouri', 'MO', 'Kansas City', '64101'],
    ['Montana', 'MT', 'Billings', '59101'],
    ['Nebraska', 'NE', 'Omaha', '68101'],
    ['Nevada', 'NV', 'Las Vegas', '89101'],
    ['New Hampshire', 'NH', 'Manchester', '03101'],
    ['New Jersey', 'NJ', 'Newark', '07101'],
    ['New Mexico', 'NM', 'Albuquerque', '87101'],
    ['New York', 'NY', 'New York', '10001'],
    ['North Carolina', 'NC', 'Charlotte', '28201'],
    ['North Dakota', 'ND', 'Fargo', '58102'],
    ['Ohio', 'OH', 'Columbus', '43201'],
    ['Oklahoma', 'OK', 'Oklahoma City', '73101'],
    ['Oregon', 'OR', 'Portland', '97201'],
    ['Pennsylvania', 'PA', 'Philadelphia', '19101'],
    ['Rhode Island', 'RI', 'Providence', '02901'],
    ['South Carolina', 'SC', 'Charleston', '29401'],
    ['South Dakota', 'SD', 'Sioux Falls', '57101'],
    ['Tennessee', 'TN', 'Nashville', '37201'],
    ['Texas', 'TX', 'Houston', '77001'],
    ['Utah', 'UT', 'Salt Lake City', '84101'],
    ['Vermont', 'VT', 'Burlington', '05401'],
    ['Virginia', 'VA', 'Richmond', '23219'],
    ['Washington', 'WA', 'Seattle', '98101'],
    ['West Virginia', 'WV', 'Charleston', '25301'],
    ['Wisconsin', 'WI', 'Milwaukee', '53201'],
    ['Wyoming', 'WY', 'Cheyenne', '82001']
  ];

  var FIRST = [
    'Sarah',
    'Michael',
    'Jessica',
    'David',
    'Emily',
    'James',
    'Ashley',
    'Robert',
    'Amanda',
    'Daniel',
    'Lauren',
    'Christopher',
    'Megan',
    'Matthew',
    'Nicole',
    'Andrew',
    'Stephanie',
    'Joshua',
    'Rachel',
    'Ryan',
    'Jennifer',
    'Kevin',
    'Laura',
    'Brian',
    'Michelle'
  ];
  var LAST = [
    'J.',
    'T.',
    'L.',
    'M.',
    'K.',
    'R.',
    'S.',
    'P.',
    'H.',
    'W.',
    'B.',
    'C.',
    'N.',
    'D.',
    'G.'
  ];
  var SERVICES = ['Plumbing', 'Electrical', 'Painting', 'Moving', 'Cleaning', 'HVAC'];

  var SERVICE_DETAILS = {
    plumbing: {
      pick: 'Plumbing',
      title: 'Plumbing',
      sub: 'Leaks, clogs, pipes, water heaters & more',
      price: '$89',
      hero: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&w=1200&q=80',
      lead: 'Licensed plumbers handle emergencies and planned repairs with upfront pricing and same-day availability in your area.',
      includes: [
        'Leak detection & pipe repair',
        'Drain cleaning & clog removal',
        'Faucet, toilet & fixture installs',
        'Water heater service',
        'Emergency same-day visits'
      ],
      gallery: [
        'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=600&q=80'
      ]
    },
    electrical: {
      pick: 'Electrical',
      title: 'Electrical',
      sub: 'Wiring, panels, outlets, lighting & safety',
      price: '$95',
      hero: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=80',
      lead: 'Certified electricians for safe installs, panel upgrades, and troubleshooting — all work meets local code.',
      includes: [
        'Outlet & switch replacement',
        'Ceiling fan & light installs',
        'Panel upgrades & breakers',
        'Whole-home safety inspections',
        'EV charger setup'
      ],
      gallery: [
        'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=600&q=80'
      ]
    },
    painting: {
      pick: 'Painting',
      title: 'Painting',
      sub: 'Interior & exterior rooms, trim & cabinets',
      price: '$150',
      hero: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&w=1200&q=80',
      lead: 'Professional painters deliver clean lines, protected floors, and premium finishes for every room.',
      includes: [
        'Room prep & surface repair',
        'Interior wall & ceiling paint',
        'Trim, doors & cabinet refinishing',
        'Exterior siding & deck stain',
        'Color consultation included'
      ],
      gallery: [
        'https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=600&q=80'
      ]
    },
    moving: {
      pick: 'Moving',
      title: 'Moving',
      sub: 'Local moves, packing & furniture handling',
      price: '$199',
      hero: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1200&q=80',
      lead: 'Insured moving crews protect your furniture and finish on schedule — local and in-home moves available.',
      includes: [
        'Loading & unloading',
        'Furniture wrapping & padding',
        'Apartment & house moves',
        'Packing supplies on request',
        'Assembly & placement help'
      ],
      gallery: [
        'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=600&q=80'
      ]
    },
    cleaning: {
      pick: 'Cleaning',
      title: 'Cleaning',
      sub: 'Deep cleans, move-out & recurring service',
      price: '$79',
      hero: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80',
      lead: 'Background-checked cleaners bring supplies and follow a detailed checklist for every room.',
      includes: [
        'Kitchen & bathroom deep scrub',
        'Dusting, vacuum & mop',
        'Move-in / move-out cleans',
        'Inside windows & baseboards',
        'Eco-friendly products available'
      ],
      gallery: [
        'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?auto=format&fit=crop&w=600&q=80'
      ]
    },
    hvac: {
      pick: 'HVAC',
      title: 'HVAC',
      sub: 'Heating, cooling, tune-ups & ventilation',
      price: '$120',
      hero: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80',
      lead: 'HVAC technicians restore comfort fast with seasonal tune-ups, repairs, and system replacements.',
      includes: [
        'AC & furnace repair',
        'Seasonal maintenance tune-ups',
        'Thermostat installs',
        'Duct cleaning & airflow checks',
        'Emergency heating & cooling'
      ],
      gallery: [
        'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=600&q=80'
      ]
    }
  };

  function renderServiceDetail(slug) {
    var s = SERVICE_DETAILS[slug];
    if (!s) return { title: 'Service', sub: '', body: '<p>Service not found.</p>' };
    return {
      title: s.title,
      sub: s.sub,
      body:
        '<p class="bc-svc-detail-lead">' +
        esc(s.lead) +
        '</p><ul class="bc-svc-detail-includes">' +
        s.includes
          .map(function (item) {
            return '<li>' + esc(item) + '</li>';
          })
          .join('') +
        '</ul><div class="bc-svc-detail-gallery">' +
        s.gallery
          .map(function (url) {
            return (
              '<img src="' +
              url +
              '" alt="' +
              esc(s.title + ' project') +
              '" loading="lazy" width="600" height="360">'
            );
          })
          .join('') +
        '</div><p class="bc-svc-detail-price">From <strong>' +
        esc(s.price) +
        '</strong> in your area</p><button type="button" class="bc-btn bc-btn-primary bc-btn-block" data-bc-panel-pick-service="' +
        esc(s.pick) +
        '">Book ' +
        esc(s.title) +
        ' pro</button>'
    };
  }

  var reviewsCache = null;
  function getReviews() {
    if (reviewsCache) return reviewsCache;
    reviewsCache = [];
    for (var i = 0; i < 100; i++) {
      var city = US_CITIES[i % US_CITIES.length];
      reviewsCache.push({
        author: FIRST[i % FIRST.length] + ' ' + LAST[i % LAST.length],
        quote: REVIEW_QUOTES[i % REVIEW_QUOTES.length],
        service: SERVICES[i % SERVICES.length],
        city: city[0] + ', ' + city[1],
        img: 'https://i.pravatar.cc/80?u=bc' + i,
        stars: i % 7 === 0 ? 4 : 5
      });
    }
    home.querySelectorAll('.bc-review-list article').forEach(function (art, idx) {
      var q = art.querySelector('p');
      var a = art.querySelector('strong');
      if (q && a && reviewsCache[idx]) {
        reviewsCache[idx].quote = q.textContent.replace(/^"|"$/g, '');
        reviewsCache[idx].author = a.textContent.trim();
      }
    });
    return reviewsCache;
  }

  function getLocation() {
    try {
      var s = localStorage.getItem('bc_location');
      if (s) return JSON.parse(s);
    } catch (e) {}
    return { city: 'New York', state: 'NY', zip: '10001', label: 'New York, NY' };
  }

  function setLocation(loc, silent) {
    try {
      localStorage.setItem('bc_location', JSON.stringify(loc));
    } catch (e) {}
    home.querySelectorAll('[data-bc-location-label]').forEach(function (el) {
      el.textContent = loc.label;
    });
    home.querySelectorAll('[data-bc-zip]').forEach(function (el) {
      el.value = loc.zip;
    });
    if (!silent) toast('Location updated to ' + loc.label);
  }

  function applySavedLocation() {
    setLocation(getLocation(), true);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function renderReviews(filter) {
    var q = (filter || '').toLowerCase();
    var list = getReviews().filter(function (r) {
      if (!q) return true;
      return (
        r.quote.toLowerCase().indexOf(q) >= 0 ||
        r.author.toLowerCase().indexOf(q) >= 0 ||
        r.service.toLowerCase().indexOf(q) >= 0 ||
        r.city.toLowerCase().indexOf(q) >= 0
      );
    });
    var html =
      '<div class="bc-panel-search-wrap"><input type="search" class="bc-panel-search" data-bc-review-search placeholder="Search reviews by keyword, service, or city\u2026" value="' +
      esc(filter || '') +
      '"><span class="bc-panel-count">' +
      list.length +
      ' reviews</span></div><div class="bc-review-modal-list">';
    list.forEach(function (r) {
      html +=
        '<article class="bc-review-modal-item"><img src="' +
        r.img +
        '" alt="" width="44" height="44" loading="lazy"><div><div class="bc-stars sm">' +
        (r.stars === 5 ? STARS5 : '\u2605\u2605\u2605\u2605\u2606') +
        ' <span class="bc-muted">' +
        esc(r.service) +
        ' \u00b7 ' +
        esc(r.city) +
        '</span></div><p>"' +
        esc(r.quote) +
        '"</p><strong>' +
        esc(r.author) +
        '</strong></div></article>';
    });
    html += '</div>';
    return html;
  }

  function stateNameForCode(code) {
    for (var i = 0; i < US_STATES.length; i++) {
      if (US_STATES[i][1] === code) return US_STATES[i][0];
    }
    return code;
  }

  function findLocationMatches(filter) {
    var q = (filter || '').trim();
    var ql = q.toLowerCase();
    var digits = q.replace(/\D/g, '');
    var cityMatches = [];
    var stateMatches = [];
    var seenCity = {};

    if (!q) {
      return { cities: [], states: US_STATES.slice() };
    }

    US_CITIES.forEach(function (c) {
      var city = c[0];
      var st = c[1];
      var zip = c[2];
      var hay = (city + ' ' + st + ' ' + zip).toLowerCase();
      var zipHit = false;
      if (digits.length >= 3) {
        zipHit = zip.indexOf(digits) === 0;
        if (!zipHit && digits.length === 5) {
          zipHit = zip.substring(0, 3) === digits.substring(0, 3);
        }
      }
      if (hay.indexOf(ql) >= 0 || zipHit) {
        var key = city + '|' + st;
        if (seenCity[key]) return;
        seenCity[key] = true;
        cityMatches.push({
          city: city,
          state: st,
          zip: digits.length === 5 ? digits : zip,
          stateName: stateNameForCode(st)
        });
      }
    });

    US_STATES.forEach(function (s) {
      var hay = (s[0] + ' ' + s[1] + ' ' + s[2] + ' ' + s[3]).toLowerCase();
      var zipHit = digits.length >= 3 && s[3].indexOf(digits) === 0;
      if (hay.indexOf(ql) >= 0 || zipHit) {
        stateMatches.push({
          city: s[2],
          state: s[1],
          zip: digits.length === 5 ? digits : s[3],
          stateName: s[0]
        });
      }
    });

    return { cities: cityMatches, states: stateMatches };
  }

  function resolveBestLocation(filter) {
    var q = (filter || '').trim();
    if (!q) return null;
    var m = findLocationMatches(q);
    var pick = m.cities[0] || m.states[0];
    if (!pick) return null;
    return {
      city: pick.city,
      state: pick.state,
      zip: pick.zip,
      label: pick.city + ', ' + pick.state
    };
  }

  function renderStateRowButton(city, state, zip, stateName, activeCode) {
    var active = activeCode === state ? ' is-active' : '';
    return (
      '<button type="button" class="bc-state-row' +
      active +
      '" data-bc-pick-city="' +
      esc(city) +
      '|' +
      esc(state) +
      '|' +
      esc(zip) +
      '" role="listitem">' +
      '<span class="bc-state-badge" aria-hidden="true">' +
      esc(state) +
      '</span>' +
      '<span class="bc-state-meta"><strong>' +
      esc(stateName || stateNameForCode(state)) +
      '</strong><small>' +
      esc(city) +
      '</small></span>' +
      '<span class="bc-state-zip">ZIP ' +
      esc(zip) +
      '</span>' +
      '<span class="bc-state-arrow" aria-hidden="true">\u2192</span></button>'
    );
  }

  function renderStateRows(filter) {
    var q = (filter || '').trim();
    var cur = getLocation();
    var html = '';
    var n = 0;
    var seen = {};

    if (!q) {
      US_STATES.forEach(function (s) {
        n++;
        html += renderStateRowButton(s[2], s[1], s[3], s[0], cur.state);
      });
    } else {
      var matches = findLocationMatches(q);
      matches.cities.forEach(function (m) {
        var key = m.city + '|' + m.state;
        if (seen[key]) return;
        seen[key] = true;
        n++;
        html += renderStateRowButton(m.city, m.state, m.zip, m.stateName, cur.state);
      });
      matches.states.forEach(function (m) {
        var key = m.city + '|' + m.state;
        if (seen[key]) return;
        seen[key] = true;
        n++;
        html += renderStateRowButton(m.city, m.state, m.zip, m.stateName, cur.state);
      });
    }

    if (!n) {
      html = '<p class="bc-loc-empty">' + esc(bcT('loc.empty')) + '</p>';
    }
    return html;
  }

  function renderLocationPanel() {
    var cur = getLocation();
    return (
      '<div class="bc-loc-panel">' +
      '<div class="bc-loc-map" aria-hidden="true">' +
      '<span class="bc-loc-map-grid"></span>' +
      '<span class="bc-loc-map-glow"></span>' +
      '<span class="bc-loc-map-pin"></span>' +
      '<span class="bc-loc-map-ring"></span></div>' +
      '<div class="bc-loc-strip" aria-hidden="true"><span></span><span></span><span></span></div>' +
      '<p class="bc-loc-current">' +
      bcT('loc.current') +
      ' <strong data-bc-loc-current-label>' +
      esc(cur.label) +
      '</strong></p>' +
      '<div class="bc-panel-search-wrap bc-loc-search">' +
      '<input type="search" enterkeyhint="search" class="bc-panel-search" data-bc-city-search placeholder="' +
      esc(bcT('loc.searchPh')) +
      '" value="" autocomplete="off" autocorrect="off" spellcheck="false" aria-describedby="bc-loc-enter-hint">' +
      '<span class="bc-panel-count" data-bc-loc-count></span></div>' +
      '<p class="bc-loc-enter-hint" id="bc-loc-enter-hint" data-bc-t="loc.enterHint">' +
      bcT('loc.enterHint') +
      '</p>' +
      '<div class="bc-state-list-head" aria-hidden="true"><span class="bc-state-list-dot"></span>' +
      bcT('loc.listHead') +
      '</div>' +
      '<div class="bc-state-list" data-bc-city-grid role="list">' +
      renderStateRows('') +
      '</div></div>'
    );
  }

  function bindCityPickButtons() {
    bodyEl.querySelectorAll('[data-bc-pick-city]').forEach(function (btn) {
      if (btn._bcPickBound) return;
      btn._bcPickBound = true;
      btn.addEventListener('click', function () {
        var p = btn.getAttribute('data-bc-pick-city').split('|');
        setLocation({ city: p[0], state: p[1], zip: p[2], label: p[0] + ', ' + p[1] });
        closePanel();
      });
    });
  }

  function bindLocationPanelSearch() {
    var citySearch = bodyEl.querySelector('[data-bc-city-search]');
    var grid = bodyEl.querySelector('[data-bc-city-grid]');
    if (!citySearch || !grid) return;
    function syncGrid() {
      grid.innerHTML = renderStateRows(citySearch.value);
      var countEl = bodyEl.querySelector('[data-bc-loc-count]');
      var items = grid.querySelectorAll('[data-bc-pick-city]');
      if (countEl) {
        countEl.textContent = items.length + ' ' + bcT('loc.areas');
      }
      bindCityPickButtons();
    }
    function applyEnterSelection() {
      var items = grid.querySelectorAll('[data-bc-pick-city]');
      if (items.length === 1) {
        items[0].click();
        return true;
      }
      var resolved = resolveBestLocation(citySearch.value);
      if (resolved) {
        setLocation(resolved);
        closePanel();
        return true;
      }
      return false;
    }
    if (!citySearch._bcLocBound) {
      citySearch._bcLocBound = true;
      citySearch.addEventListener('input', syncGrid);
      citySearch.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (!applyEnterSelection()) syncGrid();
      });
    }
    syncGrid();
  }

  function accountAuthUrl(kind) {
    var base =
      kind === 'register'
        ? home.getAttribute('data-bc-account-register') || '/account/register'
        : home.getAttribute('data-bc-account-login') || '/account/login';
    var ret = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
    if (base.indexOf('return_url=') >= 0) return base;
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + ret;
  }

  function goAccountAuth(kind) {
    window.location.href = accountAuthUrl(kind);
  }

  function renderSignInPanel(signup) {
    var logo =
      '<svg class="bc-signin-logo" width="48" height="48" viewBox="0 0 40 40" fill="none" aria-hidden="true">' +
      '<defs><linearGradient id="bc-si-bg" x1="4" y1="4" x2="36" y2="36"><stop stop-color="#0066FF"/><stop offset="1" stop-color="#0047B3"/></linearGradient></defs>' +
      '<rect width="40" height="40" rx="11" fill="url(#bc-si-bg)"/>' +
      '<path d="M20 9L10 16v13h6v-7h8v7h6V16L20 9z" fill="#fff" fill-opacity=".96"/>' +
      '<path d="M20 13l3.5 2.6v2L20 15.2 16.5 17.6v-2L20 13z" fill="#93c5fd"/>' +
      '<circle cx="28" cy="28" r="2.2" fill="#fbbf24"/><circle cx="12" cy="28" r="2.2" fill="#fbbf24"/>' +
      '<path d="M14 28h12" stroke="#fbbf24" stroke-width="1.4" stroke-linecap="round"/></svg>';
    return (
      '<div class="bc-signin-panel">' +
      '<button type="button" class="bc-panel-close bc-signin-close" data-bc-panel-close aria-label="Close">\u2715</button>' +
      '<div class="bc-signin-top">' +
      logo +
      '<div class="bc-signin-brand-text"><strong>BuildConnect</strong><small data-bc-t="signin.tagline">' +
      bcT('signin.tagline') +
      '</small></div></div>' +
      '<div class="bc-signin-hero bc-ad-photo-live" aria-hidden="true">' +
      '<span class="bc-ad-photo-inner bc-signin-hero-photo" data-bc-signin-photo></span>' +
      '<span class="bc-ad-photo-glow"></span></div>' +
      '<div class="bc-signin-card">' +
      '<h3 class="bc-signin-title" data-bc-t="' +
      (signup ? 'signin.signupTitle' : 'signin.title') +
      '">' +
      bcT(signup ? 'signin.signupTitle' : 'signin.title') +
      '</h3>' +
      '<p class="bc-signin-sub" data-bc-t="' +
      (signup ? 'signin.signupSub' : 'signin.sub') +
      '">' +
      bcT(signup ? 'signin.signupSub' : 'signin.sub') +
      '</p>' +
      '<button type="button" class="bc-btn bc-btn-shop bc-btn-block" data-bc-signin-go="' +
      (signup ? 'register' : 'login') +
      '"><span class="bc-shop-mark" aria-hidden="true">S</span> <span data-bc-t="signin.shop">' +
      bcT('signin.shop') +
      '</span></button>' +
      '<div class="bc-signin-or"><span>or</span></div>' +
      '<form class="bc-signin-form" data-bc-signin-form data-bc-signin-kind="' +
      (signup ? 'register' : 'login') +
      '">' +
      '<label class="bc-signin-email-wrap">' +
      '<input type="email" name="email" autocomplete="email" required placeholder="' +
      esc(bcT('signin.emailPh')) +
      '">' +
      '<span class="bc-signin-email-go" aria-hidden="true">\u2192</span></label>' +
      '<button type="submit" class="bc-btn bc-btn-primary bc-btn-block" data-bc-t="signin.emailBtn">' +
      bcT('signin.emailBtn') +
      '</button></form>' +
      '<p class="bc-signin-legal" data-bc-t="signin.legal">' +
      bcT('signin.legal') +
      '</p>' +
      '<ul class="bc-signin-trust">' +
      '<li data-bc-t="signin.trust1">' +
      bcT('signin.trust1') +
      '</li>' +
      '<li data-bc-t="signin.trust2">' +
      bcT('signin.trust2') +
      '</li>' +
      '<li data-bc-t="signin.trust3">' +
      bcT('signin.trust3') +
      '</li></ul></div></div>'
    );
  }

  function bindSignInPanel() {
    var photos = GENERIC_AD_PHOTOS || [];
    var photoEl = bodyEl.querySelector('[data-bc-signin-photo]');
    if (photoEl && photos.length) {
      photoEl.style.backgroundImage = "url('" + photos[0] + "')";
    }
    bodyEl.querySelectorAll('[data-bc-signin-go]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goAccountAuth(btn.getAttribute('data-bc-signin-go') === 'register' ? 'register' : 'login');
      });
    });
    var form = bodyEl.querySelector('[data-bc-signin-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        goAccountAuth(form.getAttribute('data-bc-signin-kind') === 'register' ? 'register' : 'login');
      });
    }
  }

  var SPONSORED_ADS = {
    'metro-supply': {
      photos: [
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1200&q=85',
        'https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=85'
      ],
      titleKey: 'folder.adLeftTitle',
      tagKey: 'folder.adLeftTag',
      descKey: 'ad.metroDesc',
      hoursKey: 'ad.metroHours',
      phone: '(718) 555-0198',
      email: 'orders@metroprosupply.demo',
      web: 'https://metroprosupply.demo',
      address: '452 Atlantic Ave, Brooklyn, NY 11217'
    },
    'proshield': {
      photos: [
        'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=85',
        'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1200&q=85'
      ],
      titleKey: 'folder.adRightTitle',
      tagKey: 'folder.adRightTag',
      descKey: 'ad.shieldDesc',
      hoursKey: 'ad.shieldHours',
      phone: '(212) 555-0177',
      email: 'quotes@proshieldinsurance.demo',
      web: 'https://proshieldinsurance.demo',
      address: '120 Broadway, New York, NY 10271'
    },
    easypay: {
      photos: [
        'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=85',
        'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1200&q=85'
      ],
      titleKey: 'folder.adFinTitle',
      tagKey: 'folder.adFinTag',
      descKey: 'ad.finDesc',
      hoursKey: 'ad.finHours',
      phone: '(800) 555-0140',
      email: 'hello@easypay.demo',
      web: 'https://easypay.demo',
      address: 'Online · US nationwide'
    },
    'mobile-partner': {
      photos: [
        'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=85',
        'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=85'
      ],
      titleKey: 'folder.adMobileTitle',
      tagKey: 'folder.adMobileTag',
      descKey: 'ad.mobileDesc',
      hoursKey: 'ad.eliteHours',
      phone: '(646) 555-0133',
      email: 'featured@buildconnect-partners.demo',
      web: 'https://buildconnect-partners.demo',
      address: 'Serving your metro area'
    },
    'elite-hvac': {
      photos: [
        'https://images.unsplash.com/photo-1631545806607-1f218c802c73?auto=format&fit=crop&w=1200&q=85',
        'https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=85'
      ],
      titleKey: 'sidebar.adTitle',
      tagKey: 'sidebar.adTagline',
      descKey: 'ad.eliteDesc',
      hoursKey: 'ad.eliteHours',
      phone: '(212) 555-0188',
      email: 'book@eliteclimatepros.demo',
      web: 'https://eliteclimatepros.demo',
      address: 'Queens & Manhattan, NY'
    },
    'bright-spark': {
      photos: [
        'https://images.unsplash.com/photo-1621905252507-b35492da74b4?auto=format&fit=crop&w=1200&q=85',
        'https://images.unsplash.com/photo-1473341304170-be9716596afe?auto=format&fit=crop&w=1200&q=85'
      ],
      titleKey: 'sidebar.sp1name',
      tagKey: 'sidebar.sp1tag',
      descKey: 'ad.brightDesc',
      hoursKey: 'ad.brightHours',
      phone: '(917) 555-0162',
      email: 'service@brightsparkelectric.demo',
      web: 'https://brightsparkelectric.demo',
      address: 'Jersey City, NJ · NYC metro'
    },
    'ad-sell': {
      photos: [
        'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=85'
      ],
      titleKey: 'folder.adSell',
      tagKey: 'ad.sellDesc',
      descKey: 'ad.sellDesc',
      hoursKey: 'ad.sellHours',
      phone: '(212) 555-0100',
      email: 'ads@buildconnect.demo',
      web: 'https://buildconnect.demo/advertise',
      address: 'BuildConnect Media · New York, NY'
    }
  };

  var adSlotRotate = {};

  function getSponsoredAd(slot) {
    return SPONSORED_ADS[slot] || null;
  }

  function sponsoredAdPhoto(slot, index) {
    var ad = getSponsoredAd(slot);
    if (!ad || !ad.photos || !ad.photos.length) return '';
    var i = typeof index === 'number' ? index : 0;
    return ad.photos[i % ad.photos.length];
  }

  function applySponsoredAdPhotos() {
    home.querySelectorAll('[data-bc-ad-slot]').forEach(function (el) {
      var slot = el.getAttribute('data-bc-ad-slot');
      var url = sponsoredAdPhoto(slot, 0);
      if (!url) return;
      var inner = el.classList.contains('bc-ad-photo-inner') ? el : el.querySelector('.bc-ad-photo-inner');
      if (inner) setAdPhotoEl(inner, url);
    });
  }

  function renderSponsoredAdPanel(slot) {
    var ad = getSponsoredAd(slot);
    if (!ad) return '<p>Ad not found.</p>';
    var photo = sponsoredAdPhoto(slot, 0);
    var title = bcT(ad.titleKey);
    var tag = bcT(ad.tagKey);
    var desc = bcT(ad.descKey);
    var hours = bcT(ad.hoursKey);
    var tel = ad.phone.replace(/[^\d+]/g, '');
    return (
      '<div class="bc-ad-modal">' +
      '<button type="button" class="bc-panel-close bc-signin-close" data-bc-panel-close aria-label="Close">\u2715</button>' +
      '<div class="bc-ad-modal-hero bc-ad-photo-live">' +
      '<span class="bc-ad-photo-inner" style="background-image:url(\'' +
      esc(photo) +
      '\')"></span>' +
      '<span class="bc-ad-photo-glow"></span>' +
      '<span class="bc-ad-photo-shine"></span></div>' +
      '<span class="bc-ad-modal-badge" data-bc-t="ad.modalBadge">' +
      bcT('ad.modalBadge') +
      '</span>' +
      '<h3 class="bc-ad-modal-title">' +
      esc(title) +
      '</h3>' +
      '<p class="bc-ad-modal-tag">' +
      esc(tag) +
      '</p>' +
      '<p class="bc-ad-modal-desc">' +
      esc(desc) +
      '</p>' +
      '<h4 class="bc-ad-modal-contacts-title" data-bc-t="ad.contactsTitle">' +
      bcT('ad.contactsTitle') +
      '</h4>' +
      '<div class="bc-ad-contact-grid">' +
      '<a class="bc-ad-contact-card" href="tel:' +
      esc(tel) +
      '"><span class="bc-ad-contact-ico bc-ad-contact-ico--phone" aria-hidden="true"></span><strong data-bc-t="ad.call">' +
      bcT('ad.call') +
      '</strong><span>' +
      esc(ad.phone) +
      '</span></a>' +
      '<a class="bc-ad-contact-card" href="mailto:' +
      esc(ad.email) +
      '"><span class="bc-ad-contact-ico bc-ad-contact-ico--mail" aria-hidden="true"></span><strong data-bc-t="ad.email">' +
      bcT('ad.email') +
      '</strong><span>' +
      esc(ad.email) +
      '</span></a>' +
      '<a class="bc-ad-contact-card" href="' +
      esc(ad.web) +
      '" target="_blank" rel="noopener sponsored"><span class="bc-ad-contact-ico bc-ad-contact-ico--web" aria-hidden="true"></span><strong data-bc-t="ad.web">' +
      bcT('ad.web') +
      '</strong><span>' +
      esc(ad.web.replace(/^https?:\/\//, '')) +
      '</span></a>' +
      '<div class="bc-ad-contact-card bc-ad-contact-card--static"><span class="bc-ad-contact-ico bc-ad-contact-ico--pin" aria-hidden="true"></span><strong data-bc-t="ad.address">' +
      bcT('ad.address') +
      '</strong><span>' +
      esc(ad.address) +
      '</span></div>' +
      '<div class="bc-ad-contact-card bc-ad-contact-card--static"><span class="bc-ad-contact-ico bc-ad-contact-ico--clock" aria-hidden="true"></span><strong data-bc-t="ad.hours">' +
      bcT('ad.hours') +
      '</strong><span>' +
      esc(hours) +
      '</span></div></div>' +
      '<div class="bc-ad-modal-actions">' +
      '<a class="bc-btn bc-btn-primary" href="tel:' +
      esc(tel) +
      '" data-bc-t="ad.callNow">' +
      bcT('ad.callNow') +
      '</a>' +
      '<a class="bc-btn bc-btn-ghost" href="mailto:' +
      esc(ad.email) +
      '" data-bc-t="ad.sendEmail">' +
      bcT('ad.sendEmail') +
      '</a>' +
      '<a class="bc-btn bc-btn-light" href="' +
      esc(ad.web) +
      '" target="_blank" rel="noopener sponsored" data-bc-t="ad.visitWeb">' +
      bcT('ad.visitWeb') +
      '</a></div>' +
      '<p class="bc-ad-modal-note" data-bc-t="ad.demoNote">' +
      bcT('ad.demoNote') +
      '</p></div>'
    );
  }

  var pendingProFilter = null;

  function getPros() {
    return window.BC_PROS && window.BC_PROS.length ? window.BC_PROS : [];
  }

  function getProById(id) {
    var pros = getPros();
    for (var i = 0; i < pros.length; i++) {
      if (pros[i].id === id) return pros[i];
    }
    return null;
  }

  function renderProCard(p, showPhone) {
    var html =
      '<button type="button" class="bc-pro-dir-card" data-bc-open-panel="pro-' +
      esc(p.id) +
      '">' +
      '<img src="https://i.pravatar.cc/96?u=' +
      encodeURIComponent(p.id) +
      '" alt="" width="48" height="48" loading="lazy">' +
      '<div class="bc-pro-dir-meta">' +
      '<strong>' +
      esc(p.name) +
      ' <span class="bc-verified-badge" title="Verified">&#10003;</span></strong>' +
      '<span class="bc-stars sm">' +
      STARS5 +
      ' ' +
      esc(p.rating) +
      ' <span class="bc-muted">(' +
      esc(String(p.reviews)) +
      ')</span></span>' +
      '<span class="bc-spec">' +
      esc(p.specialty) +
      ' \u00b7 ' +
      esc(p.city) +
      '</span>';
    if (showPhone && p.phone) {
      html += '<span class="bc-pro-phone">' + esc(p.phone) + '</span>';
    }
    html += '</div></button>';
    return html;
  }

  function renderProTradeGrid(specialty) {
    var pros = getPros().filter(function (p) {
      return p.specialty === specialty;
    });
    pros.sort(function (a, b) {
      if (a.id === 'el01') return -1;
      if (b.id === 'el01') return 1;
      return a.name.localeCompare(b.name);
    });
    var html = '<div class="bc-pro-dir-grid bc-pro-dir-grid--page bc-pro-dir-grid--trade">';
    pros.forEach(function (p) {
      html += renderProCard(p, true);
    });
    html += '</div>';
    return html;
  }

  function bindProCards(root) {
    if (!root) return;
    root.querySelectorAll('[data-bc-open-panel]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pid = btn.getAttribute('data-bc-open-panel');
        if (pid) openPanel(pid);
      });
    });
  }

  function renderProDirectory(query, serviceFilter, opts) {
    opts = opts || {};
    var pros = getPros().slice();
    var q = (query || '').toLowerCase();
    var svc = serviceFilter || '';
    var shown = 0;
    var gridClass = opts.inline ? 'bc-pro-dir-grid bc-pro-dir-grid--page' : 'bc-pro-dir-grid';
    var html =
      '<div class="bc-panel-search-wrap">' +
      '<input type="search" class="bc-panel-search" data-bc-pro-search placeholder="Search by name, city, or service\u2026" value="' +
      esc(query || '') +
      '">' +
      '<select class="bc-pro-svc-filter" data-bc-pro-svc-filter aria-label="Filter by service">' +
      '<option value="">All services</option>';
    SERVICES.forEach(function (s) {
      html +=
        '<option value="' +
        esc(s) +
        '"' +
        (svc === s ? ' selected' : '') +
        '>' +
        esc(s) +
        '</option>';
    });
    html += '</select></div><div class="' + gridClass + '">';
    pros.sort(function (a, b) {
      if (a.id === 'el01') return -1;
      if (b.id === 'el01') return 1;
      return 0;
    });
    pros.forEach(function (p) {
      if (svc && p.specialty !== svc) return;
      var hay = (p.name + ' ' + p.specialty + ' ' + p.city + ' ' + p.bio).toLowerCase();
      if (q && hay.indexOf(q) < 0) return;
      shown++;
      html += renderProCard(p, !!opts.showPhone);
    });
    html += '</div>';
    if (!shown) {
      html +=
        '<p class="bc-pro-empty">No pros match your search. Try another service or clear filters.</p>';
    }
    html +=
      '<p class="bc-pro-dir-count">' +
      shown +
      ' pro' +
      (shown === 1 ? '' : 's') +
      ' shown</p>' +
      '<button type="button" class="bc-btn bc-btn-primary bc-btn-block" data-bc-panel-action="scroll-widget">Book with matched pro</button>';
    return html;
  }

  function renderProDetail(id) {
    var p = getProById(id);
    if (!p) return { title: 'Pro not found', sub: '', body: '<p>Try Find a Pro to browse all professionals.</p>' };
    return {
      title: p.name,
      sub: p.specialty + ' \u00b7 ' + p.city + ' \u00b7 ' + p.years,
      body:
        '<div class="bc-pro-detail">' +
        '<img class="bc-pro-detail-photo" src="https://i.pravatar.cc/200?u=' +
        encodeURIComponent(p.id) +
        '" alt="' +
        esc(p.name) +
        '" width="96" height="96">' +
        '<div class="bc-pro-detail-stats">' +
        '<div class="bc-stars sm">' + STARS5 + ' ' +
        esc(p.rating) +
        ' <span class="bc-muted">(' +
        esc(String(p.reviews)) +
        ' reviews)</span></div>' +
        '<p class="bc-spec">' +
        esc(p.specialty) +
        ' \u00b7 ZIP ' +
        esc(p.zip) +
        '</p></div></div>' +
        '<p class="bc-pro-detail-bio">' +
        esc(p.bio) +
        '</p>' +
        (p.website
          ? '<p class="bc-pro-detail-web"><a href="' +
            esc(p.website) +
            '" target="_blank" rel="noopener noreferrer">Visit website</a></p>'
          : '') +
        (p.phone
          ? '<p class="bc-pro-detail-phone"><strong>Phone:</strong> ' + esc(p.phone) + '</p>'
          : '') +
        '<ul class="bc-panel-list">' +
        '<li>\u2713 Background-checked &amp; insured</li>' +
        '<li>\u2713 ' +
        esc(p.years) +
        ' experience</li>' +
        '<li>\u2713 Upfront pricing before work starts</li>' +
        '</ul>' +
        '<button type="button" class="bc-btn bc-btn-primary bc-btn-block" data-bc-panel-pick-service="' +
        esc(p.specialty) +
        '">Book ' +
        esc(p.name.split(' ')[0]) +
        '</button>' +
        '<button type="button" class="bc-btn bc-btn-ghost bc-btn-block" data-bc-open-panel="find-pro">Back to all pros</button>'
    };
  }

  function panelContent(id) {
    if (id.indexOf('svc-') === 0) return renderServiceDetail(id.slice(4));
    if (id.indexOf('pro-') === 0) return renderProDetail(id.slice(4));
    if (id.indexOf('ad-') === 0) {
      return { title: '', sub: '', body: renderSponsoredAdPanel(id.slice(3)) };
    }
    var loc = getLocation();
    switch (id) {
      case 'find-pro': {
        var proFilter = pendingProFilter || '';
        pendingProFilter = null;
        return {
          title: 'Find a Pro',
          sub: getPros().length + '+ verified professionals near ' + loc.label,
          body: renderProDirectory('', proFilter)
        };
      }
      case 'how-it-works':
        return {
          title: 'How It Works',
          sub: 'Simple, transparent home services in three steps',
          body:
            '<div class="bc-panel-cards">' +
            '<div class="bc-panel-card"><img src="https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&w=600&q=80" alt=""><h3>1. Tell us what you need</h3><p>Pick a service and ZIP. Our smart match finds top-rated local pros.</p></div>' +
            '<div class="bc-panel-card"><img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=600&q=80" alt=""><h3>2. Compare verified pros</h3><p>Every pro is background-checked with license and insurance verified.</p></div>' +
            '<div class="bc-panel-card"><img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=600&q=80" alt=""><h3>3. Book with confidence</h3><p>Upfront pricing, satisfaction guarantee, and 24/7 support.</p></div>' +
            '</div>'
        };
      case 'reviews':
        return {
          title: 'Customer Reviews',
          sub: '4.8 average \u00b7 3200+ verified homeowner reviews',
          body: renderReviews('')
        };
      case 'for-pros':
        return {
          title: 'For Pros',
          sub: 'Grow your business with BuildConnect',
          body:
            '<div class="bc-panel-pro">' +
            '<ul class="bc-panel-list">' +
            '<li>\u2713 Steady local leads in your service area</li>' +
            '<li>\u2713 No upfront fees \u2014 pay only when you win jobs</li>' +
            '<li>\u2713 Build your reputation with verified reviews</li>' +
            '<li>\u2713 Mobile dashboard to manage bookings</li>' +
            '</ul>' +
            '<a class="bc-btn bc-btn-primary bc-btn-block" href="mailto:support@tavusstore.com?subject=Pro%20application">Apply to join</a>' +
            '</div>'
        };
      case 'resources':
        return {
          title: 'Resources',
          sub: 'Guides, support, and homeowner tips',
          body:
            '<div class="bc-resource-grid">' +
            '<button type="button" class="bc-resource-card" data-bc-open-panel="how-it-works"><img src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=400&q=80" alt=""><span>How It Works</span></button>' +
            '<button type="button" class="bc-resource-card" data-bc-open-panel="reviews"><img src="https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&w=400&q=80" alt=""><span>All Reviews</span></button>' +
            '<button type="button" class="bc-resource-card" data-bc-open-panel="feedback"><img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=400&q=80" alt=""><span>Contact Support</span></button>' +
            '<button type="button" class="bc-resource-card" data-bc-open-panel="location"><img src="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?auto=format&fit=crop&w=400&q=80" alt=""><span>Change Location</span></button>' +
            '</div>' +
            '<div class="bc-panel-faq"><h3>Quick answers</h3>' +
            '<details><summary>Are all pros licensed and insured?</summary><p>Yes. Every pro passes license, insurance, and identity verification.</p></details>' +
            '<details><summary>How fast can I get a pro?</summary><p>Many jobs can be booked same-day depending on service and availability.</p></details>' +
            '<details><summary>What if I am not satisfied?</summary><p>Our satisfaction guarantee covers eligible jobs \u2014 contact support anytime.</p></details>' +
            '</div>'
        };
      case 'feedback':
        return {
          title: 'Contact & Feedback',
          sub: 'We typically reply within one business day',
          body:
            '<p class="bc-feedback-direct">Email: <a href="mailto:support@tavusstore.com">support@tavusstore.com</a></p>' +
            '<form class="bc-feedback-form" data-bc-feedback-form>' +
            '<label>Name<input type="text" name="name" required placeholder="Your name"></label>' +
            '<label>Email<input type="email" name="email" required placeholder="you@email.com"></label>' +
            '<label>Topic<select name="topic"><option>General question</option><option>Booking help</option><option>Pro application</option><option>Report an issue</option></select></label>' +
            '<label>Message<textarea name="message" rows="4" required placeholder="How can we help?"></textarea></label>' +
            '<button type="submit" class="bc-btn bc-btn-primary bc-btn-block">Send message</button>' +
            '</form>'
        };
      case 'location':
        return {
          title: bcT('loc.title'),
          sub: bcT('loc.sub'),
          body: renderLocationPanel()
        };
      case 'sign-in':
        return { title: '', sub: '', body: renderSignInPanel(false) };
      case 'sign-up':
        return { title: '', sub: '', body: renderSignInPanel(true) };
      case 'services':
        return {
          title: 'All Services',
          sub: 'Popular home services in ' + loc.label,
          body:
            '<div class="bc-svc-modal-grid">' +
            SERVICES.map(function (s) {
              return (
                '<button type="button" class="bc-svc-modal-btn" data-bc-open-panel="svc-' +
                s.toLowerCase() +
                '">' +
                esc(s) +
                '</button>'
              );
            }).join('') +
            '</div>'
        };
      default:
        return { title: 'BuildConnect', sub: '', body: '<p>Coming soon.</p>' };
    }
  }

  function openPanel(id) {
    var data = panelContent(id);
    lastFocus = document.activeElement;
    var isAuth = id === 'sign-in' || id === 'sign-up';
    var isAd = id.indexOf('ad-') === 0;
    var isFullBleed = isAuth || isAd;
    var panelEl = panelRoot.querySelector('.bc-panel');
    var heroWrap = panelRoot.querySelector('.bc-panel-hero-wrap');
    var headWrap = panelRoot.querySelector('.bc-panel-head');
    if (panelEl) {
      panelEl.classList.toggle('bc-panel--signin', isAuth);
      panelEl.classList.toggle('bc-panel--ad', isAd);
    }
    panelRoot.classList.toggle('bc-panel-root--signin', isFullBleed);
    titleEl.textContent = data.title;
    subEl.textContent = data.sub;
    bodyEl.innerHTML = data.body;
    if (headWrap) headWrap.hidden = isFullBleed;
    if (heroWrap) {
      heroWrap.hidden = isFullBleed;
      heroWrap.classList.toggle('bc-panel-hero-wrap--signin', false);
    }
    if (heroEl) {
      if (isFullBleed) {
        heroEl.hidden = true;
      } else {
      var heroUrl = HERO[id];
      if (!heroUrl && id.indexOf('svc-') === 0 && SERVICE_DETAILS[id.slice(4)]) {
        heroUrl = SERVICE_DETAILS[id.slice(4)].hero;
      }
      if (!heroUrl && id.indexOf('pro-') === 0) {
        var proHero = getProById(id.slice(4));
        if (proHero) {
          heroUrl = 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80';
        }
      }
      if (heroUrl) {
        heroEl.src = heroUrl;
        heroEl.alt = data.title;
        heroEl.hidden = false;
      } else heroEl.hidden = true;
      }
    }

    panelRoot.hidden = false;
    panelRoot.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
    if (bodyEl) bodyEl.scrollTop = 0;
    var closeBtn = panelRoot.querySelector('.bc-panel-close--head') || panelRoot.querySelector('.bc-panel-close');
    if (closeBtn && !window.matchMedia('(max-width:639px)').matches) {
      try {
        closeBtn.focus({ preventScroll: true });
      } catch (err) {
        closeBtn.focus();
      }
    }
    bindPanelBody();
  }

  function closePanel() {
    panelRoot.hidden = true;
    panelRoot.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
    var panelEl = panelRoot.querySelector('.bc-panel');
    if (panelEl) panelEl.classList.remove('bc-panel--signin', 'bc-panel--ad');
    panelRoot.classList.remove('bc-panel-root--signin');
    var headWrap = panelRoot.querySelector('.bc-panel-head');
    var heroWrap = panelRoot.querySelector('.bc-panel-hero-wrap');
    if (headWrap) headWrap.hidden = false;
    if (heroWrap) heroWrap.hidden = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function bindPanelBody() {
    var search = bodyEl.querySelector('[data-bc-review-search]');
    if (search) {
      search.addEventListener('input', function () {
        bodyEl.innerHTML = renderReviews(search.value);
        bindPanelBody();
        bodyEl.querySelector('[data-bc-review-search]').focus();
      });
    }
    var citySearch = bodyEl.querySelector('[data-bc-city-search]');
    if (citySearch) {
      bindLocationPanelSearch();
    }
    if (bodyEl.querySelector('[data-bc-signin-form]')) {
      bindSignInPanel();
    }
    var proSearch = bodyEl.querySelector('[data-bc-pro-search]');
    var proSvc = bodyEl.querySelector('[data-bc-pro-svc-filter]');
    function refreshProDir() {
      var q = proSearch ? proSearch.value : '';
      var s = proSvc ? proSvc.value : '';
      bodyEl.innerHTML = renderProDirectory(q, s);
      bindPanelBody();
      var next = bodyEl.querySelector('[data-bc-pro-search]');
      if (next) {
        next.focus();
        next.setSelectionRange(next.value.length, next.value.length);
      }
    }
    if (proSearch) proSearch.addEventListener('input', refreshProDir);
    if (proSvc) proSvc.addEventListener('change', refreshProDir);
    bindCityPickButtons();
    bodyEl.querySelectorAll('[data-bc-open-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openPanel(btn.getAttribute('data-bc-open-panel'));
      });
    });
    bodyEl.querySelectorAll('[data-bc-panel-pick-service]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var svc = btn.getAttribute('data-bc-panel-pick-service');
        var sel = home.querySelector('[data-bc-service]');
        if (sel) sel.value = svc;
        closePanel();
        bookScroll();
        toast('Selected ' + svc + ' \u2014 complete booking below.');
      });
    });
    var form = bodyEl.querySelector('[data-bc-feedback-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        var name = String(fd.get('name') || '').trim();
        var email = String(fd.get('email') || '').trim();
        var topic = String(fd.get('topic') || 'General question');
        var message = String(fd.get('message') || '').trim();
        var btn = form.querySelector('button[type="submit"]');
        var btnLabel = btn ? btn.textContent : 'Send message';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Sending…';
        }
        var bodyText =
          'Topic: ' + topic + '\nReply-to: ' + email + '\n\n' + message;
        fetch('/contact', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          },
          credentials: 'same-origin',
          body: new URLSearchParams({
            form_type: 'contact',
            utf8: '\u2713',
            'contact[name]': name,
            'contact[email]': email,
            'contact[body]': bodyText
          }).toString()
        })
          .then(function (res) {
            return res.json().catch(function () {
              return {};
            }).then(function (data) {
              if (res.ok && data && data.posted_successfully) return data;
              throw new Error('contact_failed');
            });
          })
          .then(function () {
            toast('Message sent! We will reply to ' + email + ' soon.');
            form.reset();
            closePanel();
          })
          .catch(function () {
            var mail =
              'mailto:support@tavusstore.com?subject=' +
              encodeURIComponent('BuildConnect: ' + topic) +
              '&body=' +
              encodeURIComponent('Name: ' + name + '\nEmail: ' + email + '\n\n' + message);
            window.location.href = mail;
            toast('Opening email app… You can also write to support@tavusstore.com');
          })
          .finally(function () {
            if (btn) {
              btn.disabled = false;
              btn.textContent = btnLabel;
            }
          });
      });
    }
    bodyEl.querySelectorAll('[data-bc-panel-action="scroll-widget"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closePanel();
        bookScroll();
      });
    });
  }

  function bookScroll() {
    var w = home.querySelector('[data-bc-widget]');
    if (w) w.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  home.querySelectorAll('[data-bc-open-panel]').forEach(function (el) {
    function openFromEl(e) {
      if (e) e.preventDefault();
      var id = el.getAttribute('data-bc-open-panel');
      if (id === 'find-pro') {
        var spec = el.getAttribute('data-bc-pro-book');
        pendingProFilter = spec || null;
      }
      if (id) openPanel(id);
      var nav = home.querySelector('[data-bc-mobile-nav]');
      var menuBtn = home.querySelector('[data-bc-menu-btn]');
      if (nav && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        nav.hidden = true;
        if (menuBtn) menuBtn.textContent = '\u2630';
      }
    }
    el.addEventListener('click', openFromEl);
    if (el.classList.contains('bc-review-trigger')) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') openFromEl(e);
      });
    }
  });

  panelRoot.addEventListener('click', function (e) {
    if (e.target.closest('[data-bc-panel-close]')) {
      e.preventDefault();
      closePanel();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panelRoot.hidden) closePanel();
  });

  function bindProDirectoryHost(host) {
    if (!host) return;
    var inline = host.hasAttribute('data-bc-inline-pro-directory');
    var proSearch = host.querySelector('[data-bc-pro-search]');
    var proSvc = host.querySelector('[data-bc-pro-svc-filter]');
    function refresh() {
      var q = proSearch ? proSearch.value : '';
      var s = proSvc ? proSvc.value : '';
      host.innerHTML = renderProDirectory(q, s, inline ? { inline: true } : {});
      bindProDirectoryHost(host);
    }
    if (proSearch) proSearch.addEventListener('input', refresh);
    if (proSvc) proSvc.addEventListener('change', refresh);
    host.querySelectorAll('[data-bc-panel-action="scroll-widget"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        bookScroll();
      });
    });
    bindProCards(host);
  }

  function scrollToSection(id, afterScroll) {
    closePanel();
    var nav = home.querySelector('[data-bc-mobile-nav]');
    var menuBtn = home.querySelector('[data-bc-menu-btn]');
    if (nav && nav.classList.contains('is-open')) {
      nav.classList.remove('is-open');
      nav.hidden = true;
      if (menuBtn) menuBtn.textContent = '\u2630';
    }
    var target = document.getElementById(id);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (afterScroll) afterScroll();
  }

  function tradeSlug(trade) {
    return (trade || '').toLowerCase().replace(/\s+/g, '-');
  }

  function renderFeaturedStars() {
    var html = '<span class="bc-stars sm bc-stars-seq" aria-hidden="true">';
    var i;
    for (i = 0; i < 5; i++) {
      html +=
        '<span class="bc-star-chip" style="animation-delay:' +
        (i * 0.5) +
        's">\u2605</span>';
    }
    return html + '</span>';
  }

  function renderListingCard(p, opts) {
    opts = opts || {};
    var featured = !!opts.featured;
    var cardClass = 'bc-listing-card' + (featured ? ' bc-listing-card--featured' : '');
    var innerOpen = featured ? '<div class="bc-listing-card-inner">' : '';
    var innerClose = featured ? '</div>' : '';
    var vipHtml = featured
      ? '<span class="bc-vip-tag" aria-label="VIP featured pro"><span class="bc-vip-tag-text">VIP</span></span>'
      : '';
    var starsHtml = featured
      ? renderFeaturedStars()
      : '<span class="bc-stars sm">' + STARS5 + '</span>';
    return (
      '<article class="' +
      cardClass +
      '">' +
      vipHtml +
      innerOpen +
      '<img src="https://i.pravatar.cc/144?u=' +
      encodeURIComponent(p.id) +
      '" alt="" width="72" height="72" loading="lazy">' +
      '<div class="bc-listing-body">' +
      '<div class="bc-listing-top">' +
      '<h3>' +
      esc(p.name) +
      ' <span class="bc-verified-badge" title="Verified">&#10003;</span></h3>' +
      '<span class="bc-listing-rating">' +
      starsHtml +
      ' ' +
      esc(p.rating) +
      ' (' +
      esc(String(p.reviews)) +
      ')</span></div>' +
      '<p class="bc-listing-loc">' +
      esc(p.specialty) +
      ' \u00b7 ' +
      esc(p.city) +
      ' \u00b7 ' +
      esc(p.years) +
      '</p>' +
      '<p class="bc-listing-bio">' +
      esc(p.bio) +
      '</p>' +
      '<div class="bc-listing-actions">' +
      '<button type="button" class="bc-btn bc-btn-ghost bc-btn-sm" data-bc-open-panel="pro-' +
      esc(p.id) +
      '">View profile</button>' +
      (p.phone
        ? '<a class="bc-btn bc-btn-ghost bc-btn-sm" href="tel:' +
          esc(p.phone.replace(/\D/g, '')) +
          '">Call ' +
          esc(p.phone) +
          '</a>'
        : '') +
      '<button type="button" class="bc-btn bc-btn-primary bc-btn-sm" data-bc-panel-pick-service="' +
      esc(p.specialty) +
      '">Book</button>' +
      '</div></div>' +
      innerClose +
      '</article>'
    );
  }

  var TRADE_COUNTS = {
    Plumbing: 28,
    Electrical: 27,
    Painting: 24,
    Moving: 18,
    Cleaning: 26,
    HVAC: 22
  };

  function getTradeCount(trade) {
    if (TRADE_COUNTS[trade]) return TRADE_COUNTS[trade];
    return getPros().filter(function (p) {
      return p.specialty === trade;
    }).length;
  }

  function getProsForTrade(trade) {
    var pros = getPros().filter(function (p) {
      return p.specialty === trade;
    });
    pros.sort(function (a, b) {
      if (a.id === 'el01') return -1;
      if (b.id === 'el01') return 1;
      return a.name.localeCompare(b.name);
    });
    var limit = getTradeCount(trade);
    return pros.slice(0, limit);
  }

  function renderFolderFeed(trade) {
    var html = '';
    getProsForTrade(trade).forEach(function (p, idx) {
      html += renderListingCard(p, { featured: idx < 3 });
    });
    return html;
  }

  function renderFolderNav(activeTrade) {
    var html = '';
    SERVICES.forEach(function (trade) {
      var count = getTradeCount(trade);
      html +=
        '<button type="button" class="bc-folder-nav-btn' +
        (trade === activeTrade ? ' is-active' : '') +
        '" data-bc-open-folder="' +
        esc(trade) +
        '">' +
        esc(tradeLabel(trade)) +
        ' <span>' +
        count +
        '</span></button>';
    });
    return html;
  }

  var folderHub = null;
  var folderView = null;
  var folderFeed = null;
  var folderNav = null;
  var folderTitle = null;
  var folderHeading = null;
  var folderCount = null;
  var activeFolderTrade = null;

  var TRADE_PHOTOS = {
    Plumbing: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&w=1600&q=90',
    Electrical: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1600&q=90',
    Painting: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&w=1600&q=90',
    Moving: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1600&q=90',
    Cleaning: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1600&q=90',
    HVAC: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1600&q=90'
  };

  var TRADE_PHOTO_SETS = {
    Plumbing: [
      TRADE_PHOTOS.Plumbing,
      'https://images.unsplash.com/photo-1585705271555-c7b674e19b19?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1607400201888-5657181c47a7?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1600&q=90'
    ],
    Electrical: [
      TRADE_PHOTOS.Electrical,
      'https://images.unsplash.com/photo-1473341304170-be9716596afe?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1621905252507-b35492da74b4?auto=format&fit=crop&w=1600&q=90'
    ],
    Painting: [
      TRADE_PHOTOS.Painting,
      'https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1600&q=90'
    ],
    Moving: [
      TRADE_PHOTOS.Moving,
      'https://images.unsplash.com/photo-1600518464441-9154a4dea21b?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1600607687644-c7171b42498f?auto=format&fit=crop&w=1600&q=90'
    ],
    Cleaning: [
      TRADE_PHOTOS.Cleaning,
      'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1585421514738-01798e348ed9?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1527515637462-cff94ee9431d?auto=format&fit=crop&w=1600&q=90'
    ],
    HVAC: [
      TRADE_PHOTOS.HVAC,
      'https://images.unsplash.com/photo-1631545806607-1f218c802c73?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1600&q=90',
      'https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=90'
    ]
  };

  var GENERIC_AD_PHOTOS = [
    TRADE_PHOTOS.HVAC,
    TRADE_PHOTOS.Cleaning,
    TRADE_PHOTOS.Electrical,
    TRADE_PHOTOS.Plumbing,
    TRADE_PHOTOS.Moving,
    TRADE_PHOTOS.Painting,
    'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=90',
    'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=90'
  ];

  var adRotateTimer = null;
  var adRotateIndex = 0;

  function tradePhotoSet(trade) {
    return TRADE_PHOTO_SETS[trade] || TRADE_PHOTO_SETS.Plumbing;
  }

  function setAdPhotoEl(el, url) {
    if (!el || !url) return;
    el.classList.add('is-swapping');
    el.style.backgroundImage = "url('" + url + "')";
    window.setTimeout(function () {
      el.classList.remove('is-swapping');
    }, 520);
  }

  function tickAdPhotoRotation() {
    adRotateIndex = (adRotateIndex + 1) % GENERIC_AD_PHOTOS.length;
    var genericUrl = GENERIC_AD_PHOTOS[adRotateIndex];

    Object.keys(SPONSORED_ADS).forEach(function (slot) {
      var ad = SPONSORED_ADS[slot];
      if (!ad.photos || ad.photos.length < 2) return;
      adSlotRotate[slot] = ((adSlotRotate[slot] || 0) + 1) % ad.photos.length;
      var url = ad.photos[adSlotRotate[slot]];
      home.querySelectorAll('[data-bc-ad-slot="' + slot + '"]').forEach(function (wrap) {
        var inner = wrap.classList.contains('bc-ad-photo-inner') ? wrap : wrap.querySelector('.bc-ad-photo-inner');
        if (inner) setAdPhotoEl(inner, url);
      });
    });

    document.querySelectorAll('[data-bc-ad-rotate="generic"]').forEach(function (el) {
      setAdPhotoEl(el, genericUrl);
    });
    document.querySelectorAll('[data-bc-signin-photo]').forEach(function (el) {
      setAdPhotoEl(el, genericUrl);
    });
  }

  function initAdPhotoRotation() {
    if (adRotateTimer) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    adRotateTimer = window.setInterval(tickAdPhotoRotation, 5000);
  }

  function stopAdPhotoRotation() {
    if (adRotateTimer) {
      window.clearInterval(adRotateTimer);
      adRotateTimer = null;
    }
  }

  function tradeAdPhoto(trade) {
    return TRADE_PHOTOS[trade] || TRADE_PHOTOS.Plumbing;
  }

  function updateFolderRailAds() {
    var mobileWrap = document.querySelector('[data-bc-folder-rail-mobile]');
    if (mobileWrap) {
      mobileWrap.hidden = false;
      mobileWrap.setAttribute('aria-hidden', 'false');
    }
    applySponsoredAdPhotos();
  }

  var folderHero = null;

  function setFolderPageMode(on, photoUrl) {
    if (on) {
      home.classList.add('bc-folder-open');
      document.body.classList.add('bc-folder-open');
    } else {
      home.classList.remove('bc-folder-open');
      document.body.classList.remove('bc-folder-open');
    }
    if (!folderHero) folderHero = document.querySelector('[data-bc-folder-hero]');
    if (folderHero) {
      if (on && photoUrl) {
        folderHero.style.backgroundImage = "url('" + photoUrl + "')";
        folderHero.hidden = false;
        folderHero.setAttribute('aria-hidden', 'false');
      } else {
        folderHero.hidden = true;
        folderHero.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function isMobileHub() {
    return window.matchMedia('(max-width:960px)').matches;
  }

  function scrollToServicesCatalog() {
    var catalog = home && home.querySelector('.bc-catalog');
    if (catalog) {
      requestAnimationFrame(function () {
        catalog.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    }
  }

  function openServicesHub() {
    if (!folderHub || !folderView) return;
    activeFolderTrade = null;
    folderHub.hidden = false;
    folderView.hidden = true;
    setFolderPageMode(false);
    if (isMobileHub()) {
      scrollToServicesCatalog();
      if (history.replaceState) {
        history.replaceState(null, '', '#bc-services');
      }
      return;
    }
    if (history.replaceState) {
      history.replaceState(null, '', '#services-directory');
    }
  }

  function openCategoryFolder(trade, scroll) {
    if (!folderHub || !folderView || !folderFeed) return;
    activeFolderTrade = trade;
    var photo = TRADE_PHOTOS[trade] || '';
    if (folderTitle) folderTitle.textContent = tradeLabel(trade);
    if (folderHeading) {
      var loc = getLocation();
      folderHeading.textContent =
        tradeLabel(trade) + ' ' + bcT('folder.in') + ' ' + loc.label;
    }
    var count = getTradeCount(trade);
    if (folderCount) folderCount.textContent = count + ' ' + bcT('dir.prosLabel');
    if (folderNav) folderNav.innerHTML = renderFolderNav(trade);
    folderFeed.innerHTML = renderFolderFeed(trade);
    bindProCards(folderFeed);
    bindListingActions(folderFeed);
    folderHub.hidden = true;
    folderView.hidden = false;
    setFolderPageMode(true, photo);
    updateFolderRailAds();
    if (history.replaceState) {
      history.replaceState(null, '', '#folder-' + tradeSlug(trade));
    }
    if (scroll !== false) {
      requestAnimationFrame(function () {
        var dir = document.getElementById('services-directory');
        if (dir) dir.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    }
  }

  function bindListingActions(root) {
    if (!root) return;
    root.querySelectorAll('[data-bc-panel-pick-service]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var svc = btn.getAttribute('data-bc-panel-pick-service');
        var sel = home.querySelector('[data-bc-service]');
        if (sel) sel.value = svc;
        bookScroll();
        toast('Selected ' + svc + ' \u2014 complete booking below.');
      });
    });
  }

  function initFolderSystem() {
    folderHub = document.querySelector('[data-bc-services-hub]');
    folderView = document.querySelector('[data-bc-category-view]');
    folderFeed = document.querySelector('[data-bc-folder-feed]');
    folderNav = document.querySelector('[data-bc-folder-nav]');
    folderTitle = document.querySelector('[data-bc-folder-title]');
    folderHeading = document.querySelector('[data-bc-folder-heading]');
    folderCount = document.querySelector('[data-bc-folder-count]');
    if (!folderHub || !folderView) return;

    home.addEventListener('click', function (e) {
      var dirLink = e.target.closest('a[href="#services-directory"]');
      if (dirLink && isMobileHub() && !home.classList.contains('bc-folder-open')) {
        e.preventDefault();
        scrollToServicesCatalog();
        return;
      }
      var folderBtn = e.target.closest('[data-bc-open-folder]');
      if (folderBtn && home.contains(folderBtn)) {
        e.preventDefault();
        e.stopPropagation();
        openCategoryFolder(folderBtn.getAttribute('data-bc-open-folder'));
        return;
      }
      var backBtn = e.target.closest('[data-bc-back-hub]');
      if (backBtn && home.contains(backBtn)) {
        e.preventDefault();
        openServicesHub();
      }
    });

    var hash = (location.hash || '').replace('#', '');
    if (hash.indexOf('folder-') === 0) {
      var slug = hash.slice(7);
      var trade = SERVICES.filter(function (s) {
        return tradeSlug(s) === slug;
      })[0];
      if (trade) openCategoryFolder(trade, false);
    } else if (hash === 'services-directory' || hash === 'find-pros') {
      openServicesHub();
    }
  }

  document.addEventListener('bc-lang-change', function () {
    if (activeFolderTrade) {
      openCategoryFolder(activeFolderTrade, false);
    }
  });

  var inlineProsEl = null;
  var homeBooted = false;

  function loadProsJson(cb) {
    if (window.BC_PROS && window.BC_PROS.length >= 30) {
      cb();
      return;
    }
    var script = document.querySelector('script[src*="buildconnect-panels"]');
    var url = window.BC_PROS_URL;
    if (!url && script && script.src) {
      url = script.src.replace(/buildconnect-panels\.js(\?.*)?$/, 'buildconnect-pros.json');
    }
    if (!url) {
      cb();
      return;
    }
    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.length) window.BC_PROS = data;
        cb();
      })
      .catch(function () {
        cb();
      });
  }

  function bootBuildConnectHome() {
    if (homeBooted) return;
    homeBooted = true;
    initFolderSystem();
    applySavedLocation();
    initAdPhotoRotation();
    applySponsoredAdPhotos();
  }

  home.querySelectorAll('a[href^="#pros-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var id = (a.getAttribute('href') || '').replace('#', '');
      scrollToSection(id);
    });
  });

  home.querySelectorAll('[data-bc-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      scrollToSection(btn.getAttribute('data-bc-scroll-to'));
    });
  });

  home.querySelectorAll('a[href="#find-pros"], a[href="#services-directory"], a[href="#for-pros"], a[href="#bc-book-widget"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var id = (a.getAttribute('href') || '').replace('#', '');
      if (id === 'find-pros') id = 'services-directory';
      if (id === 'services-directory') openServicesHub();
      scrollToSection(id);
    });
  });

  home.querySelectorAll('[data-bc-pro-filter]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var filter = a.getAttribute('data-bc-pro-filter') || '';
      if (filter) {
        openCategoryFolder(filter);
      } else {
        openServicesHub();
        scrollToSection('services-directory');
      }
    });
  });

  home.addEventListener('click', function (e) {
    var adBtn = e.target.closest('[data-bc-open-ad]');
    if (adBtn && home.contains(adBtn)) {
      e.preventDefault();
      e.stopPropagation();
      var slot = adBtn.getAttribute('data-bc-open-ad');
      if (slot) openPanel('ad-' + slot);
    }
  });

  if (window.BC_PROS && window.BC_PROS.length >= 30) {
    bootBuildConnectHome();
  } else {
    document.addEventListener('bc-pros-ready', bootBuildConnectHome, { once: true });
    loadProsJson(function () {
      document.dispatchEvent(new Event('bc-pros-ready'));
    });
  }
})();
